import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

const URL = process.env.REACT_APP_SERVER_URL;

const VerifyEmailclientPayment = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const token = searchParams.get("token");
    const id_booking = searchParams.get("id_booking");

    if (!token || !id_booking) {
      setStatus("invalid");
      return;
    }

    const verify = async () => {
      try {
        const res = await fetch(
          `${URL}/api/booking/verify?token=${token}&id_booking=${id_booking}`
        );
        const data = await res.json();
        if (res.ok) {
          setStatus("success");
          // opcional: redirigir directo al paso de pago
          setTimeout(() => navigate("/pago/exitoso"), 2000);
        } else {
          setStatus("failed");
        }
      } catch (err) {
        console.error(err);
        setStatus("failed");
      }
    };
    verify();
  }, [searchParams, navigate]);

  if (status === "loading") return <p>Verificando...</p>;
  if (status === "success") return <p>✅ Correo verificado correctamente</p>;
  if (status === "failed") return <p>❌ El link expiró o es inválido</p>;
  return <p>❌ Link inválido</p>;
};

export default VerifyEmailclientPayment;
